import React, { Fragment, useEffect } from "react";

import Swal from 'sweetalert2'
import { FullName, clearStorage, getItemFromStorage, removeItemFromStorage, userPicUrl } from "../../utils/Helper";
import { Link, useLocation } from "react-router-dom";
import { BASE_URL, url } from "../../Config/Config";
import { useDispatch, useSelector } from "react-redux";
import { AdminDetailProfileAction, AdminLogoutAction } from "../../Redux/Action/AuthAction";
import ToastDefault from "../FieldComponets/Toast";
import { StorageConstant, VALIDATION_MESSAGE } from "../../Constants/Constants";
import { FormattedMessage, useIntl } from "react-intl";

import image from "../../assets/images/sidebar-bg.png";
// style={{ background: `url(${image}) center/cover`}}
function Sidebar() {
    const location = useLocation();
    const splitPath = location?.pathname.split('/');
    const current_page_1 = splitPath[1];
    const dispatch = useDispatch<any>();
    const intl = useIntl();
    const log_in = useSelector((state: any) => state.AdminLogInState)
    const DetailAdminProfile = useSelector((state: any) => state.DetailAdminProfileState);

    const handleLogout = async () => {

        Swal.fire({
            title: intl.formatMessage({ id: "are_you_sure" }),
            text: intl.formatMessage({ id: "are_you_logout" }),
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonColor: '#31CE36',
            cancelButtonColor: '#d33',
            showDenyButton: true,
            denyButtonText: intl.formatMessage({ id: "no" }),
            confirmButtonText: intl.formatMessage({ id: "yes" }),
        }).then(async (result) => {
            if (result.isConfirmed) {
                removeItemFromStorage("is_admin_login_token")
                await dispatch(AdminLogoutAction({}))
                window.location.href = BASE_URL + '/'
            }
        });
    }


    function capitalizeFirstLetter(str: string): string {
        if (!str) return ''; // Check if str is undefined or null
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    useEffect(() => {
        Swal.close();
    }, [location.pathname]);
    return (
        <Fragment>
            <div className="vertical-menu sidebar-bg" >
                <div data-simplebar className="h-100">
                    <div className="main-sidebar">
                        <ul className="main-sidebar-list" id="accordionExample">
                            <li className={`${current_page_1 == "" || current_page_1 == "dashboard" ? "active" : ""}`}>
                                <Link to={url + "/dashboard"}><i className="bx bx-home-circle"></i> <span><FormattedMessage id="dashboard" /></span></Link>
                            </li>
                            <li className={`${current_page_1 == "customer-management-list" || current_page_1 == "customer-details" ? "active" : ""}`}>
                                <Link to={url + "/customer-management-list"}><i className="fa fa-user"></i> <span><FormattedMessage id="customer_management" /></span></Link>
                            </li>


                            {/* <li className={`${current_page_1 == "horse-show-list" || current_page_1 == "horse-show-add" ||
                                current_page_1 == "horse-show-class-edit" || current_page_1 == "horse-show-add-step-2" ||
                                current_page_1 == "horse-show-add-step-3" || current_page_1 == "horse-show-add-step-4" ||
                                current_page_1 == "horse-show-edit" || current_page_1 == 'horse-show-edit-warm-ups'
                                || current_page_1 == 'horse-show-add-step-5' || current_page_1 == "horse-show-setting"
                                ? "active" : ""}`}>
                                <Link to={url + "/horse-show-list"}><i className="fa fa-horse"></i> <span>Salon management</span></Link>
                            </li>

                            <li className={`${current_page_1 == "class-list" || current_page_1 == "class-view" ? "active" : ""}`}>
                                <Link to={url + "/class-list"}><i className="fa fa-bars"></i> <span>Appointment management</span></Link>
                            </li> */}


                            <li className={`${current_page_1 == "category" || current_page_1 == "category-edit" || current_page_1 == "category-add"  ? "active" : ""}`}>
                                <Link to={url + "/category"}><i className="card-icon fa fa-store"></i> <span><FormattedMessage id="category_management" /></span></Link>
                            </li>

                            <li className={`${current_page_1 == "salon-list" || current_page_1 == "salon-edit" || current_page_1 == "salon-details" ? "active" : ""}`}>
                                <Link to={url + "/salon-list"}>    <i className="fas fa-spa"></i>  <span><FormattedMessage id="salon_management" /></span></Link>
                            </li>

                            <li className={`${current_page_1 == "subscription-plans" || current_page_1 == "subscription-plan-view" || current_page_1 == "subscription-plan-edit" ? "active" : ""}`}>
                                <Link to={url + "/subscription-plans"}><i className="fas fa-credit-card"></i> <span><FormattedMessage id="subscription_plans" /></span></Link>
                            </li>

                            <li
                              className={`${
                                current_page_1 == "subscription-payment-requests" ||
                                current_page_1 == "subscription-transaction-history" ||
                                current_page_1 == "offline-bank-settings"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              <a
                                className="btn btn-toggle align-items-center rounded"
                                data-bs-toggle="collapse"
                                data-bs-target="#subscription-sidebar-collapse"
                                aria-expanded="false"
                              >
                                <i className="fas fa-file-invoice-dollar"></i>
                                <span> <FormattedMessage id="subscription" /></span>
                              </a>
                              <div
                                className={`${
                                  current_page_1 == "subscription-payment-requests" ||
                                  current_page_1 == "subscription-transaction-history" ||
                                  current_page_1 == "offline-bank-settings"
                                    ? "collapse show"
                                    : "collapse"
                                }`}
                                id="subscription-sidebar-collapse"
                              >
                                <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                  <li
                                    className={`${
                                      current_page_1 == "subscription-payment-requests"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <Link to={url + "/subscription-payment-requests"}>
                                      <i className="fas fa-money-check-alt"></i>
                                      <span><FormattedMessage id="subscription_payment" /></span>
                                    </Link>
                                  </li>
                                  <li
                                    className={`${
                                      current_page_1 == "subscription-transaction-history"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <Link to={url + "/subscription-transaction-history"}>
                                      <i className="fas fa-history"></i>
                                      <span><FormattedMessage id="subscription_history" /></span>
                                    </Link>
                                  </li>
                                  <li
                                    className={`${
                                      current_page_1 == "offline-bank-settings"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <Link to={url + "/offline-bank-settings"}>
                                      <i className="fas fa-university"></i>
                                      <span><FormattedMessage id="offline_bank_settings" /></span>
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </li>

                            <li className={`${current_page_1 == "service" || current_page_1 == "service-details" ? "active" : ""}`}>
                                <Link to={url + "/service"}><i className="fas fa-concierge-bell"></i> <span><FormattedMessage id="service_management" /></span></Link>
                            </li>

                            <li className={`${current_page_1 == "booking-list" || current_page_1 == "booking-detail" ? "active" : ""}`}>
                                <Link to={url + "/booking-list"}><i className="fas fa-book-reader"></i> <span><FormattedMessage id="booking_management" /></span></Link>
                            </li>

                            {/* <li className={`${current_page_1 == "event-management" || current_page_1 == "event-view" ? "active" : ""}`}>
                                <Link to={url + "/event-management"}>    <i className="fa fa-calendar"></i>  <span>Subscription management</span></Link>
                            </li>


                            <li className={`${current_page_1 == "paid-warms-ups" || current_page_1 == "paid-warms-ups-view" ? "active" : ""}`}>
                                <Link to={url + "/paid-warms-ups"}><i className="fa fa-flag"></i> <span>Notification management</span></Link>
                            </li>
                            <li className={`${current_page_1 == "horse-entries" ? "active" : ""}`}>
                                <Link to={url + "/horse-entries"}><i className="fas fa-chess-knight"></i> <span>Customer support Customer</span></Link>
                            </li>
                            <li className={`${current_page_1 == "paid-warms-ups" || current_page_1 == "paid-warms-ups-view" ? "active" : ""}`}>
                                <Link to={url + "/paid-warms-ups"}><i className="fa fa-flag"></i> <span>Setting management</span></Link>
                            </li>

                            <li className={`${current_page_1 == "logout" || current_page_1 == "logout" ? "active" : ""}`}>
                            <Link to={url + "/paid-warms-ups"}><i className="fa fa-flag"></i> <span>Logout</span></Link>
                        </li> */}
                            {/* <li className={`${current_page_1 == "staff-list" || current_page_1 == "staff-list" ? "active" : ""}`}>
                            <Link to={url + "/staff-list"}><i className="fas fa-user-tie"></i><span>Staff nagnt</span></Link>
                        </li> */}
                            <li className={`${current_page_1 == "contact-us" || current_page_1 == "contact-us" ? "active" : ""}`}>
                                <Link to={url + "/contact-us"}><i className="fas fa-user-plus"></i><span><FormattedMessage id="user_support_management" /></span></Link>
                            </li>
                            <li className={`${current_page_1 == "cms-page" || current_page_1 == "cms-pages" ? "active" : ""}`}>
                                <Link to={url + "/cms-page"}><i className="fas fa-file-alt"></i><span><FormattedMessage id="static_content_management" /></span></Link>
                            </li>
                            <li className={`${current_page_1 == "faq-list" || current_page_1 == "faq-add" || current_page_1 == "faq-edit" ? "active" : ""}`}>
                                <Link to={url + "/faq-list"}><i className="fas fa-question-circle"></i><span><FormattedMessage id="faqs_management" /></span></Link>
                            </li>
                            <li className={`${current_page_1 == "review-rating-list"  ? "active" : ""}`}>
                                <Link to={url + "/review-rating-list"}><i className="fas fa-star"></i><span><FormattedMessage id="review_rating_management" /></span></Link>
                            </li>
                            <li className={`${current_page_1 == "notifications" ||  current_page_1 == "notification-add" ? "active" : ""}`}>
                                <Link to={url + "/notifications"}><i className="fas fa-envelope-open"></i><span><FormattedMessage id="notifications_management" /></span></Link>
                            </li>
                            <li className={`${current_page_1 == "atribute-list" || current_page_1 == "atribute-add" || current_page_1 == "atribute-edit" || current_page_1 == "cancel-management-list" || current_page_1 == "email-template" || current_page_1 =="email-template/edit" ? "active" : ""}`}> 
                                <a className="btn btn-toggle align-items-center rounded" data-bs-toggle="collapse" data-bs-target="#dashboard-collapse" aria-expanded="false">
                                <i className="fas fa-user-cog"></i><span> <FormattedMessage id="admin_setting" /></span>
                                </a>
                                <div className={`${current_page_1 == "atribute-list" || current_page_1 == "atribute-add" || current_page_1 == "atribute-edit" || current_page_1 == "cancel-management-list" || current_page_1 == "cancel-management-add"|| current_page_1 == "email-template" || current_page_1 =="email-template/edit"  || current_page_1 == "cancel-management-edit" ? "collapse show" : "collapse"}`} id="dashboard-collapse" style={{}}>
                                    <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                    <li className={`${current_page_1 == "atribute-list" || current_page_1 == "atribute-add" || current_page_1 == "atribute-edit" ? "active" : ""}`}>
                                    <Link to={url + "/atribute-list"}><i className="fas fa-ban"></i><span><FormattedMessage id="block_reason" /></span></Link>
                                    </li>
                                    <li className={`${current_page_1 == "cancel-management-list" || current_page_1 == "cancel-management-add" || current_page_1 == "cancel-management-edit" ? "active" : ""}`}>
                                    <Link to={url + "/cancel-management-list"}><i className="fas fa-window-close"></i><span><FormattedMessage id="cancel_reason" /></span></Link>
                                    </li>
                                    <li className={`${current_page_1 == "email-template" || current_page_1 == "email-template/edit"  ? "active" : ""}`}>
                                    <Link to={url + "/email-template"}><i className="far fa-envelope"></i><span><FormattedMessage id="email_template" /></span></Link>
                                    </li>
                                    </ul>
                                </div>
                            </li>
                            <li className={`${current_page_1 == "seervice" ? "active" : ""}`} style={{cursor:"pointer"}} >
                                <a onClick={() => handleLogout()} style={{color:"white"}} ><i className="fa fa-sign-out-alt"></i> <span><FormattedMessage id="logout" /></span></a>
                            </li>
                         

                        </ul>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Sidebar
